/*
 * @Description: 填写描述
 * @Author: 填写作者
 * @Date: 2022-01-10 23:36:18
 */
import './style/global.less';
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import { ConfigProvider } from '@arco-design/web-react';
import zhCN from '@arco-design/web-react/es/locale/zh-CN';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import rootReducer from './store';
import PageLayout from './layout';
import { GlobalContext } from './context';
import Login from './pages/login';
import checkLogin from './utils/checkLogin';
import storage from './utils/storage';
import './mock';
import request from './utils/request';
import { host } from './api-host';

const store = createStore(rootReducer);

function Index() {
  const defaultLang = storage.getItem('arco-lang') || 'zh-CN';
  const [lang, setLang] = useState(defaultLang);

  function getArcoLocale() {
    switch (lang) {
      case 'zh-CN':
        return zhCN;
      default:
        return zhCN;
    }
  }

  function fetchUserInfo() {
    request('get', `${host}/user/userinfo`).then((res: any) => {
      store.dispatch({
        type: 'update-userInfo',
        payload: { userInfo: res.data },
      });
    });
  }

  useEffect(() => {
    if (checkLogin()) {
      fetchUserInfo();
    } else if (window.location.pathname !== '/login') {
      window.location.href = '/login';
    }
  }, []);

  useEffect(() => {
    storage.setItem('arco-lang', lang);
  }, [lang]);

  const contextValue = {
    lang,
    setLang,
  };

  return (
    <BrowserRouter>
      <ConfigProvider
        locale={getArcoLocale()}
        componentConfig={{
          Card: {
            bordered: false,
          },
          List: {
            bordered: false,
          },
          Table: {
            border: false,
          },
        }}
      >
        <Provider store={store}>
          <GlobalContext.Provider value={contextValue}>
            <Switch>
              <Route path="/login" component={Login} />
              <Route path="/" component={PageLayout} />
            </Switch>
          </GlobalContext.Provider>
        </Provider>
      </ConfigProvider>
    </BrowserRouter>
  );
}

ReactDOM.render(<Index />, document.getElementById('root'));
